export const addPriceObjs = (...priceObjs) => {
    const { amount, divisor } = priceObjs.reduce(
        (total, price) => {
            if (!price) return total;
            const divisor = total.divisor || price.divisor;

            return {
                amount: total.amount + price.amount,
                divisor,
            };
        },
        { amount: 0, divisor: null },
    );
    if (!divisor) return undefined;
    return { amount, divisor };
};

export const subtractPriceObjs = (priceObj, priceObjToSubtract) => {
    if (!priceObj) return priceObj;
    return addPriceObjs(priceObj, negatePriceObj(priceObjToSubtract));
};

export const negatePriceObj = (priceObj) => {
    if (!priceObj) return priceObj;
    const { amount, divisor } = priceObj;
    return {
        // -0 is a valid number javascript, no idea why the distinction is made
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is#Examples
        amount: amount === 0 ? 0 : amount * -1,
        divisor,
    };
};

export const priceFromPriceObj = (priceObj) => {
    if (!priceObj) return priceObj;
    const { amount, divisor } = priceObj;

    // Should this handle rounding as well?
    return divisor ? amount / divisor : null;
};

export const priceWithDpOption = (priceObj) => {
    if (!priceObj) return priceObj;
    const { amount, divisor } = priceObj;

    return amount % divisor === 0 ? 0 : 2;
};
